import { useSelector } from 'react-redux';

const usePurchaseCTAHandler = (goalUID) => {
  const selectedGoalUID = useSelector(({ auth }) => auth.selectedGoal?.uid);
  const partPaymentStatus = useSelector(
    ({ checkout }) => checkout.partPaymentStatus?.[goalUID || selectedGoalUID]
  );
  const cashResponse = useSelector(({ checkout }) => checkout.cashResponse);
  const CTA =
    cashResponse?.has_ongoing_cash_payment ||
    cashResponse?.clash_details ||
    partPaymentStatus?.is_active_part_set
      ? 'Complete payment'
      : 'Get subscription';
  return CTA;
};

export default usePurchaseCTAHandler;
